var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("9、工资薪金百分八，超过部分可结转。（猜一个政策）")])])
}]

export { render, staticRenderFns }